import React, { useContext } from 'react';

import CargomaticInput from 'components/v2/input';
import CargomaticSelect from 'components/v2/select';
import DeleteButton from 'components/v2/buttons/DeleteButton';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { COMPLETE_STOP } from '../../constants/next-actions';
import PhoneField from './forms/PhoneField';

const contactTypes = [
  {
    name: 'Dispatch',
    localizationSlug: 'DISPATCH',
  },
  {
    name: 'Escalation',
    localizationSlug: 'ESCALATION',
  },
  {
    name: 'Finance',
    localizationSlug: 'FINANCE',
  },
  {
    name: 'Mobile',
    localizationSlug: 'MOBILE',
  },
  {
    name: 'Operations',
    localizationSlug: 'OPERATIONS',
  },
];

const PhoneContact = (props) => {
  const {
    contact: {
      name,
      contactType,
      phone,
      phoneExtension,
      email,
      isNameValid,
      isContactTypeValid,
      isPhoneValid,
      isEmailValid,
    },
  } = props;

  const phoneInputClassNames = classnames({
    border: isPhoneValid === false,
    'border-red-400': isPhoneValid === false,
    'border-solid': isPhoneValid === false,
  });

  const emailInputClassNames = classnames({
    border: isEmailValid === false,
    'border-red-400': isEmailValid === false,
    'border-solid': isEmailValid === false,
  });
  const { t } = useTranslation();
  return (
    <tr className="">
      <td className="">
        <CargomaticInput
          error={
            isNameValid === false
              ? { message: t('PLS_PROVIDE_CONTACT_NAME') }
              : {}
          }
          hideLabel
          info={t('NAME_OF_CONTACT')}
          onChange={(value) => {
            props.handlePhoneChange('name', value);
          }}
          value={name}
          maxLength={30}
        />
      </td>
      <td className="">
        <div className="w-48">
          <PhoneField
            value={phone}
            onChange={(value) => props.handlePhoneChange('phone', value)}
          />
        </div>
        {isPhoneValid === false && (
          <div>
            <span className="text-xs italic text-red">
              {t('INVALID_PHONE_NUMBER')}
            </span>
          </div>
        )}
      </td>
      <td className="">
        <CargomaticInput
          hideLabel
          placeholder={t('EXT')}
          onChange={(value) => props.handlePhoneChange('phoneExtension', value)}
          value={phoneExtension}
          maxLength={8}
        />
      </td>
      <td className="">
        <CargomaticInput
          hideLabel
          inputClassNames={emailInputClassNames}
          placeholder={titleize(t('EMAIL'))}
          error={isEmailValid === false ? { message: t('INVALID_EMAIL') } : {}}
          onChange={(value) => props.handlePhoneChange('email', value)}
          value={email}
          maxLength={50}
        />
      </td>
      <td className="">
        <CargomaticSelect
          error={
            isContactTypeValid === false
              ? { message: t('SELECT_CONTACT_TYPE') }
              : {}
          }
          selected={contactType}
          hideLabel
          items={contactTypes}
          defaultSelectLabel=""
          onSelect={(type) => props.handlePhoneChange('contactType', type.name)}
          textKey="localizationSlug"
          valueKey="name"
          showCaption
        />
      </td>
      <td className="">
        <DeleteButton onClick={() => props.onRemove(props.contact)} />
      </td>
    </tr>
  );
};

export default PhoneContact;
